/**
 * STORE_ASSET ItemTypes that may currently be put on an order.
 *
 * Every non-archived STORE_ASSET ItemType is orderable as far as colugo is
 * concerned, but operationally only these two can actually be fulfilled right
 * now, so the pickers are narrowed to them here in the frontend. The ids are the
 * same on dev and prod: 42 is the offline card, 44 the self-return QR code.
 *
 * Matching on ids means an environment whose STORE_ASSET ids differ (a stack
 * seeded from scratch, a restored database) gets an empty picker rather than a
 * wrong one — so if the picker is empty, check these ids against that
 * environment's item types before looking anywhere else.
 *
 * Temporary: drop this list (and the two call sites of
 * `isOrderableStoreAssetItemType`) once the remaining store assets can be
 * ordered again, or replace it with a flag on the ItemType itself.
 */
export const ORDERABLE_STORE_ASSET_ITEM_TYPE_IDS: readonly number[] = [42, 44];

export function isOrderableStoreAssetItemType(itemTypeId: number): boolean {
  return ORDERABLE_STORE_ASSET_ITEM_TYPE_IDS.includes(itemTypeId);
}
